import React from "react"
import { Link } from "gatsby"

import { sSubcategories } from "../styled/subcategories"
import { sLayout } from "../styled/layout"
import { getCategoryUrl } from "../utilities"

const Subcategories = ({ title, subcategories, open, toggleSubcategories }) => (
  <sSubcategories.Wrapper open={open}>
    <sLayout.Container>
      <sSubcategories.Close className="icon-close" onClick={() => toggleSubcategories()} />
      <div>
        <sSubcategories.Title>{title}</sSubcategories.Title>
        <sSubcategories.List>
          {subcategories &&
            subcategories.map(subcategory => (
              <sSubcategories.Item key={subcategory.slug}>
                <Link to={getCategoryUrl(subcategory.slug)}>{subcategory.name}</Link>
              </sSubcategories.Item>
            ))}
        </sSubcategories.List>
      </div>
    </sLayout.Container>
  </sSubcategories.Wrapper>
)

export default Subcategories
